module.exports = __webpack_public_path__ + "img/disneys-frozen.b2abc073.png";